import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    enabled: boolean;
}

export default function BackdropComponent({ enabled }: Props) {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(enabled);
  }, [enabled]); // Ejecuta solo cuando `enabled` cambia

  return (
    <div>
      <Backdrop
        sx={(theme) => ({ color: '#f7fafc', zIndex: theme.zIndex.drawer + 1 })}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
